export { default as GenericText } from './GenericText';
